import { render } from "./UnitsManagement.vue?vue&type=template&id=7ba5e174"
import script from "./UnitsManagement.vue?vue&type=script&lang=js"
export * from "./UnitsManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__